// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"c2f91cdf","37":"86442c69","119":"73560c32","121":"b5b740b1","131":"9bd645bf","215":"86fc0f9a","238":"7b3d9fc2","417":"708d4def","489":"de108df9","718":"04e9284c","734":"1c18ccc3","753":"58c69079","798":"8c110a0c","820":"21126b41","896":"c6a35e74","973":"716f7786"}[chunkId] + ".chunk.js";
};